export default "__VITE_ASSET__LSdWk9N___"